import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import MealPlanner from './pages/MealPlanner';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import SavedMeals from './pages/SavedMeals';
import MealsByIngredients from './pages/MealsByIngredients';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Account from './pages/Account';
import Landing from './pages/Landing';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';
import { pageView } from './utils/analytics';
import './styles/global.css';

// Analytics tracker component
const AnalyticsTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view on location change
    pageView(
      document.title,
      window.location.href,
      location.pathname + location.search
    );
  }, [location]);

  return null;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app-container">
          <Navbar />
          <main className="main-content">
            <AnalyticsTracker />
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/recipes-by-ingredients" element={<MealsByIngredients />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/" element={<Landing />} />
              
              {/* Protected routes */}
              <Route path="/account" element={
                <PrivateRoute>
                  <Account />
                </PrivateRoute>
              } />
              <Route path="/meal-planner" element={
                <PrivateRoute>
                  <MealPlanner />
                </PrivateRoute>
              } />
              <Route path="/saved-meals" element={
                <PrivateRoute>
                  <SavedMeals />
                </PrivateRoute>
              } />
            </Routes>
          </main>
          <Footer />
          <CookieConsent />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
